import React from 'react';

/**
 * How a table tells the editable inputs inside it that an edit did not take.
 *
 * FjEditableInput commits optimistically: on submit it shows the typed value and only re-reads
 * `props.value` when that prop changes. A rejected edit changes no data, so nothing brings the
 * field back on its own. Until FJCLOUD-4494 that was hidden - rejecting an edit re-rendered the
 * table, which rebuilt the column defs, which remounted every cell and re-initialised each input
 * from its props. The revert was the remount bug doing it by accident, and it stopped when the
 * remount did.
 *
 * So say it on purpose. Change this value and every editable input beneath the provider drops its
 * optimistic value and shows what is actually stored. The three cloud-admin tables that accept
 * edits provide their `errorMessageArray`, which gets a new identity every time an edit is
 * rejected - by validation before the request, or by the API after it - and again when the error
 * modal is dismissed. An input with nothing to revert ignores it.
 *
 * Delivered through context rather than a prop because the signal has to reach 13 cells across
 * three column modules. Wrapping them in a local component instead would give the builder a new
 * element type per rebuild, which is the remount this all came from. `revertToken` remains
 * available as a prop for a caller outside a provider.
 */
export const EditRevertContext = React.createContext<unknown>(undefined);

export default EditRevertContext;
